module.exports = __webpack_public_path__ + "static/media/i4c-ability.2c38bc7a.svg";